// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading {
  text-align: center;
  max-width: 40rem;
  margin-bottom: 2rem;
  margin-top: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/Global/Loading/LoadingMessage.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AACF","sourcesContent":[".loading {\n  text-align: center;\n  max-width: 40rem;\n  margin-bottom: 2rem;\n  margin-top: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
